var moment = require('moment')

export const calculateStressScoreTarget = (week,tss_target,targetForm) => {
    var stressScoreTarget = targetForm*0.96*week+tss_target
    stressScoreTarget = stressScoreTarget
    return(stressScoreTarget)
    
}




export function runTypePick(weekType,program_runs_per_week){
    //"Aerobic","Base","Aerobic-Tempo","Easy-longRun-Tempo"
    var runType = ["Aerobic II","Aerobic II","Aerobic II","Aerobic II","Aerobic II","Aerobic II","Aerobic II"]
    var ratioFactor = 1/program_runs_per_week
    var ratio = [ratioFactor,ratioFactor,ratioFactor,ratioFactor,ratioFactor,ratioFactor,ratioFactor]

    if (weekType ==="Base"){
        runType = ["Base","Base","Base","Base","Base","Base","Base"]
        ratio = [ratioFactor,ratioFactor,ratioFactor,ratioFactor,ratioFactor,ratioFactor,ratioFactor]
    }
    if (weekType ==="Aerobic-Tempo"){
        runType = ["Aerobic II","Aerobic II","Tempo","Easy","Easy",'Aerobic II','Aerobic II']
        ratio = [ratioFactor,ratioFactor,ratioFactor,ratioFactor*0.7,ratioFactor*0.7,ratioFactor,ratioFactor]
    }
    if (weekType==="LongRun-Aerobic"){
        runType = ["Long run","Aerobic II","Aerobic II","Easy","Easy",'Aerobic II','Aerobic II']
        ratio = [ratioFactor*1.10,ratioFactor*0.95,ratioFactor*0.95,ratioFactor*0.7,ratioFactor*0.8,ratioFactor,ratioFactor]
    }
    if (weekType==="LongRun-Tempo-Easy"){
        runType = ["Long run","Easy","Tempo","Easy","Easy",'Aerobic II','Aerobic II']
        ratio = [ratioFactor*1.20,ratioFactor*0.85,ratioFactor*0.95,ratioFactor*0.7,ratioFactor*0.8,ratioFactor,ratioFactor]
    }
    if (weekType==="LongRun-Interval-Easy"){
        runType = ["Long run","Easy","Interval","Easy","Easy",'Aerobic II','Aerobic II']
        ratio = [ratioFactor*1.20,ratioFactor*0.85,ratioFactor*0.95,ratioFactor*0.7,ratioFactor*0.7,ratioFactor,ratioFactor]
    }



    if (weekType==="AerobicI-Tempo"){
        runType = ["AerobicI","AerobicI","Tempo","Easy","Aerobic I",'AerobicI',"Easy"]
        ratio = [ratioFactor,ratioFactor,ratioFactor,ratioFactor*0.7,ratioFactor*0.9,ratioFactor,ratioFactor*0.7]
    }
    if (weekType==="AerobicI-LongRun-Tempo"){
        runType = ["Long run","Easy","Tempo","Easy","Aerobic I",'Aerobic I','Easy']
        ratio = [ratioFactor*1.20,ratioFactor*0.75,ratioFactor*0.95,ratioFactor*0.7,ratioFactor,ratioFactor*0.9,ratioFactor*0.7]
    }
    if (weekType==="LongRun-AerobicI"){
        runType = ["Long run","Aerobic I","Aerobic I","Easy",'Aerobic II',"Easy",'Aerobic I']
        ratio = [ratioFactor*1.20,ratioFactor*0.90,ratioFactor*0.90,ratioFactor*0.7,ratioFactor,ratioFactor*0.7,ratioFactor*0.9]
    }
    if (weekType==="LongRun-Interval-AerobicI"){
        runType = ["Long run","Easy","Interval","Easy",'Aerobic I',"Easy",'Aerobic I']
        ratio = [ratioFactor*1.20,ratioFactor*0.75,ratioFactor*0.95,ratioFactor*0.7,ratioFactor*0.9,ratioFactor*0.7,ratioFactor*0.9]
    }


    //console.log(runType,ratio)
    if (weekType==="AerobicI-LongRun-Tempo(adv)"){
        runType = ["Long run","Easy","Tempo","Easy","Interval",'Easy','Aerobic I']
        ratio = [ratioFactor*1.20,ratioFactor*0.85,ratioFactor*0.95,ratioFactor*0.7,ratioFactor*0.7,ratioFactor,ratioFactor]
    }
    if (weekType==="AerobicI-LongRun-Tempo(adv)"){
        runType = ["Long run","Easy","Tempo","Easy","Interval",'Easy','Aerobic I']
        ratio = [ratioFactor*1.20,ratioFactor*0.8,ratioFactor*0.95,ratioFactor*0.7,ratioFactor*0.85,ratioFactor*0.7,ratioFactor]
    }
    return [runType,ratio]
}





export function durationCalculate(tss,runType,user){

    var rest = user.rest_hr
    var maxh = user.max_hr
    var lactate = user.lactate_th
    var male = user.male
    var k = 1.92
    if (male=="false"){
        k = 1.67
    }
    
    var hthr = (lactate-rest)/(maxh-rest)
    var hour_lthr = 60 * hthr *0.64* Math.exp(k*hthr)
    

    //console.log(hthr,hour_lthr,k)
    // restFactor is a metric to calibrate the classic percentage of max formula that is used in some of the equations to the karvonen formula. Basically it reduces the target heart rate for an activity as the rest hr
    var restHrFactor = (60 - user.rest_hr)*0.003
    
    if (runType === "Aerobic II"){
        var hr = (0.857868-restHrFactor)*maxh///parseInt(rest) + reserve * 0.80
    
        var hrr = (hr-rest)/(maxh-rest)
        var trimp = hour_lthr * tss/100
        var duration = trimp/(hrr*0.64*Math.exp(k*hrr))    
    }
    if (runType === "Tempo"){
        hr = (0.8934-restHrFactor/2)*maxh////parseInt(rest) + reserve * 0.85
        
        hrr = (hr-rest)/(maxh-rest)
        trimp = hour_lthr * tss/100
        duration = trimp/(hrr*0.64*Math.exp(k*hrr))  
    }
    if (runType === "Long run"){
        var runningIndex = localStorage.getItem("runningIndex")
        hr = (0.77-restHrFactor)*maxh
        if (runningIndex < 42){
            hr = (0.79-restHrFactor)*maxh
        }
    
        hrr = (hr-rest)/(maxh-rest)
        trimp = hour_lthr * tss/100
        duration = trimp/(hrr*0.64*Math.exp(k*hrr))     
    }
    if (runType === "Base"){
        hr = (0.7614-restHrFactor)*maxh//parseInt(rest) + reserve * 0.70
       
        hrr = (hr-rest)/(maxh-rest)
        trimp = hour_lthr * tss/100
        duration = trimp/(hrr*0.64*Math.exp(k*hrr))     
    } 
    if (runType === "Interval"){
        hr = maxh
      
        hrr = (hr-rest)/(maxh-rest)
        trimp = hour_lthr * tss/100
        duration = trimp/(hrr*0.64*Math.exp(k*hrr))    
    } 
    if (runType === "Easy"){
        hr = (maxh*0.80-restHrFactor)
        hrr = (hr-rest)/(maxh-rest)
        trimp = hour_lthr * tss/100
        duration = trimp/(hrr*0.64*Math.exp(k*hrr))    
    } 

    if (runType === "Aerobic I"){
        hr = (0.80-restHrFactor)*maxh///parseInt(rest) + reserve * 0.80
    
        hrr = (hr-rest)/(maxh-rest)
        trimp = hour_lthr * tss/100
        duration = trimp/(hrr*0.64*Math.exp(k*hrr))    
    }
    return (duration.toFixed(2))
    
}



export function calculateActivitySpeed(duration,runType ,user){
    var restHrFactor = (60 - user.rest_hr)*0.003
    var speed = AerobicSpeedCalculate(duration,restHrFactor)
    if (runType === "Tempo"){
        speed = TempoSpeedCalculate(duration,restHrFactor)
        
    }
    if (runType === "Long run"){
        var runningIndex = localStorage.getItem("runningIndex")
        var aerobicSpeed = AerobicSpeedCalculate(duration,restHrFactor)
        var baseSpeed = BaseSpeedCalculate(duration,restHrFactor)
        if (runningIndex < 42){
            
            speed = (parseFloat(aerobicSpeed)+parseFloat(baseSpeed))/2.13
        }
        else{
            speed = baseSpeed
        }
        
        
    }
    if (runType === "Base"){
        speed = BaseSpeedCalculate(duration,restHrFactor)
        
    }
    if (runType === "Easy"){
        speed = EasySpeedCalculate(duration,restHrFactor)
        
    }
    if (runType === "Interval"){
        speed = IntervalSpeedCalculate(duration)
        
    }
    if (runType === "Aerobic I"){
        speed = AerobicOneSpeedCalculate(duration,restHrFactor)
        
    }
    //speedConvert = convertMetrics(speed)
    return speed.toFixed(2)
}




export function AerobicSpeedCalculate(duration,restHrFactor){
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.857868 - restHrFactor   ///percent of max (hr/max)
    var x = (factor*1.45)-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    
    return (speed)
}
export function AerobicOneSpeedCalculate(duration,restHrFactor){
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.80 - restHrFactor   ///percent of max (hr/max)
    var x = (factor*1.45)-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    
    return (speed)
}
export function EasySpeedCalculate(duration,restHrFactor){
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.80 - restHrFactor   ///percent of max (hr/max)
    var x = (factor*1.45)-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    
    return (speed)
}
export function BaseSpeedCalculate(duration,restHrFactor){
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.76 - restHrFactor   ///percent of max (hr/max)
    var x = factor*1.45-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    return (speed)
}
export function TempoSpeedCalculate(duration,restHrFactor){
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.895 -restHrFactor/2  ///percent of max (hr/max)
    var x = factor*1.45-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    return (speed)
}
export function IntervalSpeedCalculate(duration){
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = 1    ///percent of max (hr/max)
    var x = factor*1.45-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    return (speed)
}


export function distanceEstimation (duration,speed){
    const measurementSystem = localStorage.getItem("measurementSystem")
    var est_distance = ((duration * speed)*1000/60).toFixed(0) 
    if (measurementSystem === "Imperial mile/hr"){
        est_distance = (est_distance/1000)*0.621371192
        return(est_distance.toFixed(2))
    }
    if (measurementSystem === "Imperial min/mile"){
        est_distance = (est_distance/1000)*0.621371192
        return(est_distance.toFixed(2))
    }
    else{
        return(est_distance)
    }
}


export function planPickersDataset(value){
    if (value === "Basic plan Base period"){
        return "Base,Base,Base,Base"
    }
    if (value === "Basic plan 1 Month 1"){
        return "Aerobic,Aerobic,Aerobic,LongRun-Aerobic"
    }
    if (value === "Basic plan 1 Month 2"){
        return "LongRun-Aerobic,LongRun-Aerobic,LongRun-Tempo-Easy,LongRun-Tempo-Easy"
    }
    if (value === "Basic plan 1 Month 3"){
        return "LongRun-Tempo-Easy,LongRun-Interval-Easy,LongRun-Tempo-Easy,LongRun-Interval-Easy"
    }

    if (value === "Basic plan Base period"){
        return "Base,Base,Base,Base"
    }
    if (value === "Basic plan 2 Month 1"){
        return "AerobicI,AerobicI,AerobicI,LongRun-Aerobic"
    }
    if (value === "Basic plan 2 Month 1"){
        return "Aerobic,Aerobic,Aerobic,LongRun-Aerobic"
    }
    if (value === "Basic plan 2 Month 2"){
        return "LongRun-AerobicI,LongRun-AerobicI,AerobicI-LongRun-Tempo,AerobicI-LongRun-Tempo"
    }
    if (value === "Basic plan 2 Month 3"){
        return "AerobicI-LongRun-Tempo,LongRun-Interval-AerobicI,AerobicI-LongRun-Tempo,LongRun-Interval-AerobicI"
    }

    if (value === "Advance plan 1 Month 1"){
        return "LongRun-AerobicI,LongRun-AerobicI,AerobicI-LongRun-Tempo,AerobicI-LongRun-Tempo"
    }
    if (value === "Advance plan 1 Month 2"){
        return  "AerobicI-LongRun-Tempo(adv),AerobicI-LongRun-Tempo(adv),AerobicI-LongRun-Tempo(adv),AerobicI-LongRun-Tempo(adv)"
    }
    if (value === "Advance plan 1 Month 3"){
        return  "AerobicI-LongRun-Tempo(adv),AerobicI-LongRun-Tempo(adv),AerobicI-LongRun-Tempo(adv),AerobicI-LongRun-Tempo(adv)"
    }
}


export function tss_target_calculate(targetForm){
    var currentFitness=localStorage.getItem("fitness")
    var currentFatigue=localStorage.getItem("fatigue") 
    //alert(currentFatigue,currentFitness)
    const factor = targetForm+targetForm*0.19
    var form = currentFatigue-currentFitness
    var tss_target = (1.116*currentFitness-0.16*currentFatigue+factor)*(7.7-form*0.03)
    return tss_target
}   

export function createProjectedDatesFromRunningProgram(dateStart,numberOfRuns,tssList){
    var initialRatio = 28/(numberOfRuns*4)
    var ratio = 0
    var dates = []
    var date = moment(dateStart)
    var totalNumberOfRuns = 4*numberOfRuns
    for (var i = 0;i<totalNumberOfRuns;i++){
        console.log(ratio)
        date = date.add(Math.round(ratio),'day')
        dates.push(date.format("MM/DD/yyyy"))
        ratio = ratio - Math.round(ratio)
        ratio = ratio + initialRatio
    }
    return dates

}

